import React from 'react';
import PropTypes from 'prop-types';
import query from './query.graphql';
import OtherResponseTable from '../OtherResponseTable';

const OtherExitReason = props => {
    return (
        <OtherResponseTable
            filters={props.filters}
            settings={props.settings}
            query={query}
            field="specifyExitReason"
            table={props.table}
            groupLevel={props.groupLevel}
        />
    );
};

OtherExitReason.propTypes = {
    filters: PropTypes.object,
    table: PropTypes.object,
    settings: PropTypes.object,
    groupLevel: PropTypes.string,
};

export default OtherExitReason;
